import React from "react";
import {
  ACTION_BUTTON_TYPE,
  MainSection as MainSectionType,
  BUTTON_TEXT_MAPPING,
} from "../../UniFiPartnerHub.types";
import * as S from "./MainSection.styles";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";
import { Points } from "../Points/Points";
import { Action } from "pages/LayoutComponents/Questions/Questions";
import { CustomPoints } from "../CustomPoints/CustomPoints";
import { useTranslation } from "hooks/useTranslation";

export const MainSection = ({ section }: { section: MainSectionType }) => {
  const { t } = useTranslation();

  const getButtonText = (buttonType: ACTION_BUTTON_TYPE): string => {
    return t(BUTTON_TEXT_MAPPING[buttonType]);
  };

  return (
    <>
      <MicrositeHeading
        title={section.header.title}
        description={section.header.description}
        isCentered
        spacing={{ top: section.customWhiteSpaceTop ?? 64 }}
      />
      <S.MainSection>
        <S.ImgCopyContainer>
          <S.ImgContainer $isDisplayedFirst={section.imgFirst}>
            <S.Img src={section.img.src} alt={section.img.alt} />
          </S.ImgContainer>
          {section.points ? (
            <Points points={section.points} />
          ) : (
            <CustomPoints points={section.customPoints} />
          )}
        </S.ImgCopyContainer>
        {section.disclaimer && (
          <S.Disclaimer>{section.disclaimer}</S.Disclaimer>
        )}
        <S.ActionContainer>
          <Action href={section.buttonLink}>
            {getButtonText(section.buttonType)}
          </Action>
        </S.ActionContainer>
      </S.MainSection>
    </>
  );
};
